import HouseType from '../houseType';
import RoomObject from '../room';
export default class Townhouse extends HouseType {
  constructor() {
    super();
    this.id = 'townhouse';
    this.name = "Rekkehus";
    this.icon = "mdi-home-group";

    this.defaultRooms = [
      new RoomObject('Entry'),
      new RoomObject('Livingroom'),
      new RoomObject('Kitchen'),
      new RoomObject('Bathroom'),
      new RoomObject('Bedroom'),
      new RoomObject('Bedroom'),
      new RoomObject('Bedroom'),
      new RoomObject('Outside')
    ];
  }
}